var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMac(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffda44"
    },
    width: 512,
    height: 341.337,
    y: 85.333
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d80027"
    },
    points: "383.875 426.662 256 252.286 282.827 426.662"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d80027"
    },
    points: "133.565 85.33 256 252.286 230.314 85.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d80027"
    },
    points: "229.171 426.662 256 252.286 128.124 426.662"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d80027"
    },
    points: "0 85.33 0 212.9 256 252.286 28.333 85.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d80027"
    },
    points: "0 426.662 18.212 426.662 256 252.286 0 291.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d80027"
    },
    points: "256 252.286 512 212.9 512 85.33 483.669 85.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d80027"
    },
    points: "281.686 85.33 256 252.286 378.434 85.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d80027"
    },
    points: "512 426.662 512 291.671 256 252.286 493.787 426.662"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#d80027"
    },
    cx: 256,
    cy: 252.29,
    r: 59.359
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffda44"
    },
    cx: 256,
    cy: 252.29,
    r: 44.522
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMac);
export default __webpack_public_path__ + "static/media/mac.1a07382fe669cee8ff7967675a3018d2.svg";
export { ForwardRef as ReactComponent };